import ViewsTerms from '@/views/terms/ViewsTerms.vue';

import {home} from '@/router/breadcrumbs';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/terms',
        name: 'terms',
        component: ViewsTerms,
        meta: {
            breadcrumbs: [home]
        }
    }
] as RouteRecordRaw[]
